import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, DepartmentDto, DepartmentReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import DepartmentInline, { DepartmentInlineProps } from "./DepartmentInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity?: DepartmentDto | DepartmentReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<DepartmentInlineProps>;
}

export default function DepartmentLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.DepartmentRead]}
      to={ROUTE_PATH.DEPARTMENT_VIEW(entity?.id || entityId || "")}
      content={
        <DepartmentInline
          entity={entity}
          entityId={entityId}
          {...inlineProps}
          withTooltip={false}
        />
      }
      {...otherProps}
    />
  );
}
